declare global {
  interface Window {
    Clerk?: {
      loaded?: boolean;
      session?: { getToken: () => Promise<string | null> } | null;
      signOut?: () => Promise<void>;
    };
  }
}

let clerkReadyPromise: Promise<void> | null = null;

function waitForClerkLoaded(): Promise<void> {
  if (window.Clerk?.loaded) return Promise.resolve();

  if (!clerkReadyPromise) {
    clerkReadyPromise = new Promise<void>((resolve) => {
      const maxMs = 5_000;
      const intervalMs = 50;
      let elapsed = 0;
      const id = setInterval(() => {
        elapsed += intervalMs;
        if (window.Clerk?.loaded || elapsed >= maxMs) {
          clearInterval(id);
          clerkReadyPromise = null;
          resolve();
        }
      }, intervalMs);
    });
  }
  return clerkReadyPromise;
}

export async function getClerkToken(): Promise<string | null> {
  await waitForClerkLoaded();

  const clerkInstance = window.Clerk;
  if (!clerkInstance?.session) return null;
  return clerkInstance.session.getToken();
}
